//地址数据
//http://preapi.ectcm.com:8060/
//http://api.ectcm.com:8060/
export default {
    //下载收据
    receiptDownload: '/api/file/receiptDownload',
    //下载出席证明
    certificateDownload: '/api/file/certificateDownload',
    //加入學會活動
    joinActivity: '/api/activity/signUp',
    //学会报名支付结果查询
    getPayResult: '/api/activity/getPayResult',
    getHomeInfos: '/api/association/getAssociationIndex',
    getAssociationDetail: '/api/association/getAssociationDetailByID',
    //学术文化列表
    getArticleList: '/api/article/getWebArticleList',
    //学术文化详情
    getArticleDetail: '/api/article/getArticleDetail',
    //最新学术文化
    getNewArticleList: '/api/article/getLatestArticleList',
    //最热学术文化
    getHotArticleList: '/api/article/getVistsPopArticleList',
    //课程活动列表
    getActivityList: '/api/activity/getWebActivityListByAssId',
    //课程活动详情
    getActivityDetail: '/api/activity/gettDetail',
    //最近活動列表
    getNewActivityList: '/api/activity/getLatestActivityList',
    //学会活动照片
    getActivityPhotos: '/api/atvphotos/getWebActivityPhotos',
    //学会活动照片详情
    getActivityPhotoDetail: '/api/atvphotos/getAtvPhotosDetail',
    //学会资讯列表
    getNewsList: '/api/assnews/getWebAssNewsList',
    //学会资讯详情
    getNewsDetail: '/api/assnews/getWebAssNewsDetail',
    //学会资讯分类列表
    getNewsCategoryList: '/api/assnewscat/getWebArticleList',
    //加入学会
    joinAssociation: '/api/association/applyAssociation',
    
    //登录
    login: '/api/user/login',
    //退出登录
    logout: '/api/user/signOut',
    //注册
    register: '/api/user/clientRegister',
    //获取验证码
    getVCode: '/api/vcode/getVCode',
    //忘记密码
    resetPassword: '/api/user/resetPwd',
    //修改密码
    updatePassword: '/api/user/updatePwd',
    //获取用户信息
    getUserInfo: '/api/user/getClientById',
    //获取地区
    getAreaList: '/api/area/getAreaByParentId',
    //图片上传
    uploadImage: '/api/file/uploadImage',
    //学会报名信息回填
    getActivityInfo: '/api/user/getClientMasterInfo',
    //查询我已经报名的学会
    getMyActivitys: '/api/activity/getSignUpActivityList',
    //出席證明下載答題
    getActivityQuestions: 'api/activity/getActivityExams',
    //檢查答題的答案是否正確
    checkActivityAnswer: 'api/activity/checkActivityExamAnswer',
    //学会报名重新支付
    rePayActivityCost: 'api/activity/againPay',
    //学会网站登录协议勾选
    checkedProtocol: 'api/user/recordSiteDescCheck',
    //获取我的问题卡列表
    getMyQuestionList: 'api/v1/questionBank/queryPageList',
    //获取问题卡详情
    queryQuestionBankItems: 'api/v1/questionBank/queryQuestionBankItems',
    //获取问题答案
    getQuestionAnswer: 'api/v1/questionBank/getQuestionAnswer',
    //记录复习进度
    recordSchedule: 'api/v1/questionBank/recordSchedule',
    //恢复题目标识,错题,忽略题等
    recoverMark: 'api/v1/questionBank/recoverMark',
    //完成答题
    completeLearn: 'api/v1/questionBank/completeLearn',
    //重置学习记录
    resetLearnRecord: 'api/v1/questionBank/resetLearnRecord',
    //查看已完成的题库复习记录
    queryCompletedLearnRecord: 'api/v1/questionBank/queryCompletedLearnRecord',
}